import React from "react";
import { Link } from "react-router-dom";
import styles from './CustomButton.module.scss'
import {Button} from "antd";
import {ButtonProps} from "antd/es/button/button";

interface CustomButtonProps extends ButtonProps {
    text: string;
    link?: string;
    onClick?: () => void;
    disable: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({ text, link, onClick, disable, ...props }) => {
    if (link) {
        return (
            <Link
                to={disable ? "#" : link}
                className={styles.button}
                onClick={(e) => disable && e.preventDefault()}
            >
                {text}
            </Link>
        );
    }

  return (
        <Button
            onClick={onClick}
            disabled={disable}
            className={styles.button}

            {...props}
        >
            {text}
        </Button>
    );
};

export default CustomButton;
